import { render, staticRenderFns } from "./WarehouseLocationsPage.vue?vue&type=template&id=6f86e6b0"
import script from "./WarehouseLocationsPage.vue?vue&type=script&lang=js"
export * from "./WarehouseLocationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports